import script from "./PageToolbarApprovalDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageToolbarApprovalDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./PageToolbarApprovalDropdown.vue?vue&type=style&index=0&id=5fd6b386&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd6b386"]])

export default __exports__